import React from 'react'
import PropTypes from 'prop-types'

const ApplePayIcon = ({ width, height }) => (
  <svg width={width} height={height} viewBox='0 0 49 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1855_2827)'>
      <path
        d='M8.95757 2.57947C8.38335 3.25502 7.4646 3.78785 6.54585 3.71173C6.43101 2.79831 6.88081 1.82781 7.40718 1.22838C7.9814 0.533802 8.98628 0.0390356 9.79976 0.000976562C9.89546 0.952451 9.52222 1.8849 8.95757 2.57947ZM9.79019 3.89251C8.45991 3.81639 7.32105 4.64417 6.68941 4.64417C6.04819 4.64417 5.08159 3.93057 4.02886 3.9496C2.6603 3.96863 1.38745 4.73932 0.68882 5.96672C-0.746727 8.42153 0.315578 12.0562 1.70327 14.0543C2.38277 15.0438 3.19624 16.1285 4.26812 16.0904C5.28257 16.0524 5.68452 15.4339 6.90952 15.4339C8.14409 15.4339 8.49819 16.0904 9.57007 16.0714C10.6802 16.0524 11.3789 15.0819 12.0584 14.0923C12.8335 12.9696 13.1494 11.8754 13.1685 11.8183C13.1494 11.7993 11.0248 10.9905 11.0056 8.55474C10.9865 6.51858 12.6804 5.54807 12.757 5.49099C11.8 4.0828 10.307 3.93057 9.79019 3.89251ZM17.4751 1.13323V15.9667H19.7912V10.8954H22.9972C25.9257 10.8954 27.9833 8.89727 27.9833 6.00478C27.9833 3.1123 25.964 1.13323 23.0738 1.13323H17.4751ZM19.7912 3.07424H22.4613C24.471 3.07424 25.6195 4.13989 25.6195 6.0143C25.6195 7.8887 24.471 8.96387 22.4517 8.96387H19.7912V3.07424ZM32.2134 16.0809C33.6681 16.0809 35.0175 15.3483 35.63 14.1875H35.6779V15.9667H37.8216V8.58328C37.8216 6.44246 36.099 5.06282 33.448 5.06282C30.9884 5.06282 29.1701 6.46149 29.1031 8.38347H31.1894C31.3617 7.47005 32.2134 6.87062 33.381 6.87062C34.7974 6.87062 35.5917 7.52714 35.5917 8.73552V9.55378L32.7015 9.72505C30.0123 9.8868 28.5576 10.981 28.5576 12.8839C28.5576 14.8059 30.0601 16.0809 32.2134 16.0809ZM32.8355 14.3207C31.6009 14.3207 30.8162 13.7308 30.8162 12.8269C30.8162 11.8944 31.5722 11.3521 33.0173 11.2664L35.5917 11.1047V11.942C35.5917 13.3311 34.405 14.3207 32.8355 14.3207ZM40.6832 20.001C42.9417 20.001 44.0041 19.1446 44.9324 16.5471L48.9998 5.20554H46.6455L43.9179 13.9686H43.8701L41.1425 5.20554H38.7212L42.6451 16.0048L42.4345 16.6613C42.0804 17.7745 41.5062 18.2027 40.4822 18.2027C40.3003 18.2027 39.9462 18.1837 39.8027 18.1646V19.9439C39.9367 19.9819 40.5109 20.001 40.6832 20.001Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_1855_2827'>
        <rect width={width} height={height} fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

const defaultProps = {
  width: 49,
  height: 20
}

ApplePayIcon.propTypes = propTypes
ApplePayIcon.defaultProps = defaultProps
export default ApplePayIcon
